export default {
  getClientName(state) {
    return `${state.client?.name}`;
  },
  getRepInfo(state) {
    return state.rep;
  },
  getPageOne: (state) => (id) => {
    return state.pages.find((page) => page.id === id);
  },
  getPageOneStatic: (state) => (id) => {
    // console.log("🚀 ~ file: purlGetters.js ~ line 9 ~ id", state.pages);
    return state.allCmsPages.find((page) => page.id === id);
  },
  getPageChildren: (state) => (parentId) => {
    return state.pages.filter((page) => page.parentId === parentId);
  },
  getPageByRouteName: (state) => (routeName) => {
    return state.pages.find((page) => page.routeName === routeName);
  },
  getPagesMain: (state) => {
    return state.pages.filter((page) => page.parentId === 0);
  },
  getAllPages: (state) => {
    return state.pages;
  },
};
